<template>
  <div class="widget-card-content">
    <h2 class="content-title">{{title}}</h2>

    <p v-if="text" class="widget-card-description">{{text}}</p>
  </div>
</template>

<script>

export default {
  name: 'WidgetCardW9Form',
  props: {
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="stylus" scoped>
.widget-card-description {
  margin-top: 30px;
  @media (max-width 480px) {
    margin-top: 25px;
  }
}
</style>
